import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import pure from 'recompose/pure';
import Typography from '@material-ui/core/Typography';
import Husky from '../../images/husky.png';

import sanitizeRestProps from 'ra-ui-materialui/lib/field/sanitizeRestProps';

const TextField = ({ className, source, record = {}, ...rest }) => {

  let date1 = new Date(record._createdAt);
  let date2 = new Date(record.time);
  date1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
  date2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
  var ms = Math.abs(date1-date2);
  let daysDiff = Math.floor(ms/1000/60/60/24);
  let color = "#151515";
  if (daysDiff > 2) {
    color = "#ff5e54";
  } else if (daysDiff > 1) {
    color = "#d1ce5d";
  }

  let resultText = get(record, source);
  if (record.busted) {
    resultText = <img width='15px' height='15px' src={Husky} />;
  }

  return (
    <Typography
      component="span"
      body1="body1"
      className={className}
      {...sanitizeRestProps(rest)}
      style={{color: color}}
    >
      {resultText}
    </Typography>
  );
};

TextField.propTypes = {
  addLabel: PropTypes.bool,
  basePath: PropTypes.string,
  className: PropTypes.string,
  cellClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
  sortBy: PropTypes.string,
  source: PropTypes.string.isRequired,
};

const PureTextField = pure(TextField);

PureTextField.defaultProps = {
  addLabel: true,
};

export default PureTextField;



// WEBPACK FOOTER //
// ./src/components/ejected/TextField.js